import type React from 'react';

const TicketButtonGroupedListSkeleton: React.FC<{
    items?: number;
    selectedDate?: string | 'all';
}> = ({ items, selectedDate }) => {
    const isDateFilterEnabled = selectedDate !== 'all';
    return (
        <div className="flex flex-col grow overflow-x-auto">
            {!isDateFilterEnabled && (
                <div className="bg-[rgba(var(--primary-color-rgb),0.2)] rounded-4 w-full h-[24px] mb-8" />
            )}
            <div className="w-auto h-[132px] flex flex-row space-x-3 items-center">
                {[...Array(Math.max(0, items ?? 4))].map((_, index) => (
                    <div
                        key={`TicketButtonGroupedSkeleton${index}`}
                        className="flex-none w-[200px] h-full bg-[var(--surface-color)] rounded-8 animate-pulse-skeleton"
                    />
                ))}
            </div>
        </div>
    );
};

export default TicketButtonGroupedListSkeleton;
